import { render, staticRenderFns } from "./ModalLeadNote.vue?vue&type=template&id=495a325c"
import script from "./ModalLeadNote.vue?vue&type=script&lang=js"
export * from "./ModalLeadNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports